module.exports = __webpack_public_path__ + "vue/img/ai-search.3f4713bc.jpg";